(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sticky-add-to-cart')) {
    customElements.define(
      'sticky-add-to-cart',
      class StickyAddToCart extends HTMLElement {
        connectedCallback() {
          if (this._relocating) {
            this._relocating = false;
            this.init();
            return;
          }

          if (document.body && this.parentElement !== document.body) {
            this._relocating = true;
            document.body.appendChild(this);
            return;
          }

          this.init();
        }

        disconnectedCallback() {
          if (this._relocating) return;
          if (this.observer) this.observer.disconnect();
          if (this.formObserver) this.formObserver.disconnect();
          if (this.overlayObserver) this.overlayObserver.disconnect();
          document.body.removeEventListener('modalOpen', this.onOverlayChange);
          document.body.removeEventListener('modalClosed', this.onOverlayChange);
          if (this.onResize) window.removeEventListener('resize', this.onResize);
          if (this.unsubscribeVariant) this.unsubscribeVariant();
        }

        init() {
          this.mainVisible = true;
          this.footerVisible = false;
          this.buttonEl = this.querySelector('.sticky-atc__button');
          this.labelEl = this.querySelector('[data-sticky-atc-label]');
          this.imageEl = this.querySelector('.sticky-atc__image');
          this.variantEl = this.querySelector('[data-sticky-atc-variant]');

          this.bindObservers();
          this.bindVariantUpdates();
          this.watchFormChanges();
          this.bindOverlayWatch();
          this.syncFromMainButton();
          this.updateVisibility();

          this.onResize = () => {
            if (this.observer) this.observer.disconnect();
            this.createObserver();
          };
          window.addEventListener('resize', this.onResize);
        }

        getHeaderHeight() {
          const raw = getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim();
          const parsed = Number.parseFloat(raw);
          return Number.isFinite(parsed) ? parsed : 85;
        }

        isDisplayed(el) {
          if (!el || !el.isConnected) return false;
          const style = window.getComputedStyle(el);
          return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
        }

        findTrigger() {
          const form = this.dataset.formId ? document.getElementById(this.dataset.formId) : null;
          const scope = form || document;
          const wrapper = scope.querySelector('.product-form__buttons') || scope.querySelector('.js-sticky-atc-trigger');
          if (wrapper && wrapper !== this && !this.contains(wrapper)) return wrapper;

          const submitButton = document.getElementById(this.dataset.target);
          if (submitButton && this.isDisplayed(submitButton)) return submitButton;
          if (submitButton) {
            return submitButton.closest('.product-form__buttons') || submitButton.closest('product-form') || submitButton;
          }

          const fallback = Array.from(document.querySelectorAll('.js-sticky-atc-trigger')).find(
            (el) => el !== this && !this.contains(el)
          );
          return fallback || form || null;
        }

        bindObservers() {
          this.mainButton = this.findTrigger();
          this.footer = document.querySelector(this.dataset.footerSelector || 'footer.footer');
          this.createObserver();
        }

        watchFormChanges() {
          const form = this.dataset.formId ? document.getElementById(this.dataset.formId) : document.querySelector('product-form');
          const root = form ? form.closest('.product-form') || form.parentElement || form : null;
          if (!root || typeof MutationObserver === 'undefined') return;

          this.formObserver = new MutationObserver(() => {
            const nextTrigger = this.findTrigger();
            if (nextTrigger !== this.mainButton) {
              if (this.observer) this.observer.disconnect();
              this.bindObservers();
              this.updateVisibility();
            }
            this.syncFromMainButton();
          });
          this.formObserver.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'hidden', 'class'] });
        }

        overlayIsOpen() {
          return Array.from(document.body.classList).some(
            (name) => name === 'overflow-hidden' || name.startsWith('overflow-hidden-')
          );
        }

        bindOverlayWatch() {
          this.onOverlayChange = () => this.syncOverlayState();
          document.body.addEventListener('modalOpen', this.onOverlayChange);
          document.body.addEventListener('modalClosed', this.onOverlayChange);

          if (typeof MutationObserver !== 'undefined') {
            this.overlayObserver = new MutationObserver(this.onOverlayChange);
            this.overlayObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
          }

          this.syncOverlayState();
        }

        syncOverlayState() {
          this.classList.toggle('is-under-overlay', this.overlayIsOpen());
        }

        isNotifyMeLabel(text) {
          return /notify\s*me/i.test(String(text || '').trim());
        }

        soldOutLabel() {
          return (window.variantStrings && window.variantStrings.soldOut) || 'Sold out';
        }

        addToCartLabel() {
          return (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart';
        }

        applyUnavailableState(unavailable) {
          if (!this.buttonEl) return;
          const isUnavailable = Boolean(unavailable);
          this.buttonEl.disabled = isUnavailable;
          if (isUnavailable) {
            this.buttonEl.removeAttribute('name');
            this.buttonEl.setAttribute('type', 'button');
            if (this.labelEl) this.labelEl.textContent = this.soldOutLabel();
          } else {
            this.buttonEl.setAttribute('name', 'add');
            this.buttonEl.setAttribute('type', 'submit');
            if (this.labelEl) this.labelEl.textContent = this.addToCartLabel();
          }
        }

        syncFromMainButton() {
          const submitButton = document.getElementById(this.dataset.target);
          const form = this.dataset.formId ? document.getElementById(this.dataset.formId) : null;
          const mainCta = (submitButton && this.isDisplayed(submitButton) ? submitButton : null) ||
            (form && form.querySelector('.product-form__submit, .product-form__buttons button, .product-form__buttons [type="button"]'));
          if (!mainCta) return;

          const label = (mainCta.textContent || '').trim();
          if (this.isNotifyMeLabel(label) || mainCta.disabled) {
            this.applyUnavailableState(true);
          }
        }

        createObserver() {
          const headerHeight = this.getHeaderHeight();

          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (this.mainButton && entry.target === this.mainButton) {
                  this.mainVisible = entry.isIntersecting;
                }
                if (this.footer && entry.target === this.footer) {
                  this.footerVisible = entry.isIntersecting;
                }
              });
              this.updateVisibility();
            },
            {
              threshold: 0,
              rootMargin: `-${headerHeight}px 0px 0px 0px`,
            }
          );

          if (this.mainButton) this.observer.observe(this.mainButton);
          if (this.footer) this.observer.observe(this.footer);
          if (!this.mainButton) this.mainVisible = false;
        }

        bindVariantUpdates() {
          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange.bind(this));
          }
        }

        onVariantChange(event) {
          const html = event && event.data && event.data.html;
          const variant = event && event.data && event.data.variant;
          const source = html && html.querySelector('sticky-add-to-cart');

          if (source) {
            const newLabel = source.querySelector('[data-sticky-atc-label]');
            const newVariant = source.querySelector('[data-sticky-atc-variant]');
            const newImage = source.querySelector('.sticky-atc__image');
            const newButton = source.querySelector('.sticky-atc__button');
            const sourceLabel = newLabel ? newLabel.textContent.trim() : '';
            const unavailable = (newButton && newButton.disabled) || this.isNotifyMeLabel(sourceLabel);

            if (this.variantEl && newVariant) this.variantEl.textContent = newVariant.textContent.trim();
            if (this.imageEl && newImage) {
              this.imageEl.src = newImage.src;
              this.imageEl.alt = newImage.alt || this.imageEl.alt;
            }
            this.applyUnavailableState(unavailable);
            if (!unavailable && this.labelEl && sourceLabel && !this.isNotifyMeLabel(sourceLabel)) {
              this.labelEl.textContent = sourceLabel;
            }
            return;
          }

          if (!variant) {
            this.syncUnavailable(true);
            return;
          }

          if (this.variantEl && variant.title && variant.title !== 'Default Title') {
            this.variantEl.textContent = variant.title;
          }

          this.syncUnavailable(!variant.available);
        }

        syncUnavailable(unavailable) {
          this.applyUnavailableState(unavailable);
        }

        updateVisibility() {
          const show = !this.mainVisible && !this.footerVisible;
          this.classList.toggle('is-visible', show);
          this.setAttribute('aria-hidden', show ? 'false' : 'true');
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
